<script>
    export let teamName = '';
    export let results = {};
    export let lang = 'pl';
    import { texts, teamColours } from './texts.js';
    import { fade } from 'svelte/transition';
    let resultLabels = {
        teamA: '',
        teamB: '',
        teamC: '',
        teamD: '',
    };
    $: defineResultLabels(results, teamName);

    function defineResultLabels(results, teamName) {
        let comp = results[teamName].score;
        for (let prop in resultLabels) {
            if (prop === teamName) {
                resultLabels[prop] = comp;
            } else {
                let diff = results[teamName].score - results[prop].score;
                let ml = '';
                diff < 0
                    ? (ml = texts[lang].results_more)
                    : (ml = texts[lang].results_less);
                if (Math.abs(diff) < 4) {
                    resultLabels[prop] = texts[lang].results_give_take;
                } else if (Math.abs(diff) < 10) {
                    resultLabels[
                        prop
                    ] = `${texts[lang].results_little} ${ml} ${texts[lang].results_than_you}`;
                } else
                    resultLabels[
                        prop
                    ] = `${texts[lang].results_much} ${ml} ${texts[lang].results_than_you}`;
            }
        }
    }
</script>

<div class="log-title">
    <h2>{texts[lang].summary_header}</h2>
</div>
<div class="log-list">
    <table class="table">
        <thead class="thead">
            <tr>
                <th>{texts[lang].round}</th>
                <th class="log-orange"
                    >{teamColours[lang][results.teamA.colour]}</th
                >
                <th class="log-green"
                    >{teamColours[lang][results.teamB.colour]}</th
                >
                <th class="log-violet"
                    >{teamColours[lang][results.teamC.colour]}</th
                >
                <th class="log-blue"
                    >{teamColours[lang][results.teamD.colour]}</th
                >
            </tr>
        </thead>
        <tbody>
            {#each Array(results.gameRound - 1) as round, i}
                <tr transition:fade id="roundx">
                    <td id="roundx">{i + 1}</td>
                    {#each ['teamA', 'teamB', 'teamC', 'teamD'] as team}
                        <td class:last_round={results.gameRound === i + 2}>
                            {texts[lang][results[team].roundBoy[i]] ||
                                '???'}{#if results[team].roundMap[i]}+<i
                                    class="fas fa-map"
                                />{/if}{#if i >= 3}<br />{texts[lang][
                                    results[team].roundGirl[i]
                                ] || '???'}
                            {/if}
                            {#if results.gameRound === i + 2}<div
                                    class="hidden-score-trigger"
                                >
                                    ?
                                    <div class="hidden-score">
                                        {#if results[team].roundBoy[results.gameRound - 2] === 'pirat'}
                                            {texts[lang].currentRoundBrief
                                                .pirate1}
                                            {results[team].currentRoundBrief
                                                .pirateTotal}
                                            <i class="fas fa-coins" />
                                            {texts[lang].currentRoundBrief
                                                .pirate2}
                                            {results[team].currentRoundBrief
                                                .pirate}
                                            <i class="fas fa-coins" />
                                        {:else}
                                            {texts[lang].currentRoundBrief
                                                .explorer}
                                            {results[team].currentRoundBrief
                                                .explorer}
                                            <i class="fas fa-coins" />
                                        {/if}
                                        {texts[lang].currentRoundBrief.stolen}
                                        {results[team].currentRoundBrief.stolen}
                                        <i class="fas fa-coins" />
                                        {#if results[team].currentRoundBrief.ines}{texts[
                                                lang
                                            ].currentRoundBrief.ines}
                                            {results[team].currentRoundBrief
                                                .ines}
                                            <i
                                                class="fas fa-coins"
                                            />{/if}{#if results[team].currentRoundBrief.natives}{texts[
                                                lang
                                            ].currentRoundBrief.natives}
                                            {results[team].currentRoundBrief
                                                .natives}
                                            <i class="fas fa-coins" />
                                        {/if}
                                    </div>
                                </div>
                            {/if}
                        </td>
                    {/each}
                </tr>
            {/each}
            <!-- {#if !results.isGameEnd}
                {#if results.gameRound > 1}
                    <tr>
                        <td id="totalscoreBefore">Wynik poprzednio</td>
                        <td id="scoreBA">
                            {results.teamA.resultBefore || '0'}
                        </td>
                        <td id="scoreBB">
                            {results.teamB.resultBefore || '0'}
                        </td>
                        <td id="scoreCC">
                            {results.teamC.resultBefore || '0'}
                        </td>
                        <td id="scoreDD">
                            {results.teamD.resultBefore || '0'}
                        </td>
                    </tr>
                {/if} 
            {/if} -->
            {#if teamName === 'trener'}
                <tr>
                    <td id="totalscore">{texts[lang].summary_previous}</td>
                    <td id="scoreBA">
                        {results.teamA.resultBefore || '0'}
                    </td>
                    <td id="scoreBB">
                        {results.teamB.resultBefore || '0'}
                    </td>
                    <td id="scoreCC">
                        {results.teamC.resultBefore || '0'}
                    </td>
                    <td id="scoreDD">
                        {results.teamD.resultBefore || '0'}
                    </td>
                </tr>{/if}
            {#if results.isGameEnd}
                <tr>
                    <td id="totalscoreBefore">{texts[lang].gold_on_ship}</td>
                    <td id="scoreA">{results.teamA.score + 51}</td>
                    <td id="scoreB">{results.teamB.score + 44}</td>
                    <td id="scoreC">{results.teamC.score + 29}</td>
                    <td id="scoreD">{results.teamD.score + 37}</td>
                </tr>
                <tr>
                    <td id="loan">{texts[lang].loan_value}</td>
                    <td id="scoreA">-51</td>
                    <td id="scoreB">-44</td>
                    <td id="scoreC">-29</td>
                    <td id="scoreD">-37</td>
                </tr>
                <tr>
                    <td id="totalscore">{texts[lang].result}</td>
                    <td id="scoreA">{results.teamA.score}</td>
                    <td id="scoreB">{results.teamB.score}</td>
                    <td id="scoreC">{results.teamC.score}</td>
                    <td id="scoreD">{results.teamD.score}</td>
                </tr>
            {:else if teamName === 'trener'}
                <tr>
                    <td id="totalscore">{texts[lang].result}</td>
                    <td id="scoreA">{results.teamA.score} </td>
                    <td id="scoreB">{results.teamB.score} </td>
                    <td id="scoreC">{results.teamC.score} </td>
                    <td id="scoreD">{results.teamD.score} </td>
                </tr>
            {:else}
                <tr>
                    <td id="totalscore">{texts[lang].result}</td>
                    <td id="scoreA">{resultLabels.teamA} </td>
                    <td id="scoreB">{resultLabels.teamB} </td>
                    <td id="scoreC">{resultLabels.teamC} </td>
                    <td id="scoreD">{resultLabels.teamD} </td>
                </tr>
            {/if}
            <tr>
                <td id="totalscore">Wiersz niewidoczny!</td>
                <td id="scoreA">00</td>
                <td id="scoreB">00</td>
                <td id="scoreC">00</td>
                <td id="scoreD">00</td>
            </tr>
            <tr class:plaza={results.gameRound < 3 || results.isGameEnd}>
                <td id="totalscore">{texts[lang].beach}</td>
                <td id="scoreBA">
                    {results.teamA.roundBeach[results.gameRound - 2] || '0'}
                </td>
                <td id="scoreBB">
                    {results.teamB.roundBeach[results.gameRound - 2] || '0'}
                </td>
                <td id="scoreCC">
                    {results.teamC.roundBeach[results.gameRound - 2] || '0'}
                </td>
                <td id="scoreDD">
                    {results.teamD.roundBeach[results.gameRound - 2] || '0'}
                </td>
            </tr>
        </tbody>
    </table>

    <slot />
</div>
